export default "__VITE_ASSET__DPU11HPg__"